import { Card } from '@nextui-org/react';
import React from 'react';
import { useDispatch } from 'react-redux';
import { finalizeProcessingPayment } from '../../../store/processingPayment/slice';
import CancelIcon from '@mui/icons-material/Cancel';
import PageLayout from '../../components/common/PageLayout';
import PurchaseSessionStepsHeader from '../../components/common/PurchaseSessionStepsHeader';
import { PurchaseSessionStep } from '../../../constants/purchaseSession';
import theme from '../../theme';
import Typography from '../../components/common/Typography';
import AdminDataFooter from '../../components/common/AdminDataFooter';
import Button from '../../components/common/Button';

export default function PaymentFailedPage() {

  const dispatch = useDispatch();

  const onBack = () => {
    dispatch(finalizeProcessingPayment())
  }

  return (
    <PageLayout>
      <PurchaseSessionStepsHeader
        selectedStep={PurchaseSessionStep.CONFIRM} />
      <div className='flex flex-1 justify-center items-center'>
        <Card className='p-16 gap-8' style={{maxWidth: '500px'}}>
          <CancelIcon
            style={{
              fontSize: theme.sizing.x12,
              color: theme.color.error, 
              marginLeft: 'auto', 
              marginRight: 'auto'
            }}/>
          <Typography
            variant='headline3'
            className='text-center' 
            style={{fontWeight: 300}}>
              L'acquisto del piano non è andato a buon fine
          </Typography>
          <Button
            title='INDIETRO'
            onClick={onBack}/>
        </Card>
      </div>
      <AdminDataFooter colorVariant='text' />
    </PageLayout> 
  )
}